import { Stack } from '@mui/material';
import { Virtuoso } from 'react-virtuoso';
import { NoResults } from '../../shared/NoResults';
import {
  SelectedDependencyWithClearHistoryProps,
  ConfigurationType,
  SelectedDependency,
} from '../../dependencies/types';
import { OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS } from '../../helpers';
import { useCardListHandleDeepLink } from './useCardListHandleDeepLink';
import { useIsCanvasUnited } from '../../../../hooks/useIsCanvasUnited';
import { CardListItem } from './CardListItem';

interface CardListProps {
  list: CardListItem[];
  containerRef?: any;
  firstHistoryItem?: SelectedDependency;
  handleSetConfigurationItem: (props: SelectedDependencyWithClearHistoryProps) => void;
  withDetailedContentForRelatedObjects?: boolean;
  withApiNameOnHover?: boolean;
}

export interface CardListItem {
  id: string;
  dependencyType: string;
  parentType: ConfigurationType;
  metadataId: string;
  name: string;
  label: string;
  objectName: string;
  referencedObjects: string[];
  changedAt?: string;
  changedBy?: string;
  isActive: boolean;
}

export const CardsList = ({
  list,
  containerRef,
  firstHistoryItem,
  handleSetConfigurationItem,
  withDetailedContentForRelatedObjects: withDetailedContent,
  withApiNameOnHover,
}: CardListProps) => {
  const isCanvasUnited = useIsCanvasUnited();
  useCardListHandleDeepLink({ list, handleSetConfigurationItem });

  if (!list.length) {
    return (
      <Stack pl={2}>
        <NoResults />
      </Stack>
    );
  }

  return (
    <Virtuoso
      ref={containerRef}
      style={{
        height: `calc(100vh - ${
          isCanvasUnited ? OCCUPIED_SPACE_SINGLE_OBJECT_VIEW_CANVAS : '250px'
        })`,
      }}
      data={list}
      itemContent={(index, item) => (
        <CardListItem
          item={item}
          firstHistoryItem={firstHistoryItem}
          handleSetConfigurationItem={handleSetConfigurationItem}
          withDetailedContentForRelatedObjects={withDetailedContent}
          withApiNameOnHover={withApiNameOnHover}
        />
      )}
    />
  );
};
